"use client";
import React from "react";
import PrivacyChoicesLink from "./PrivacyChoicesLink";

interface PlatformShellProps {
  children: React.ReactNode;
}

const containerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  background: "white",
  color: "#0f172a",
};

const contentStyle: React.CSSProperties = {
  display: "flex",
  flex: "1 0 auto",
  justifyContent: "center",
};

const innerStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: 640,
};

const footerStyle: React.CSSProperties = {
  boxSizing: "border-box",
  width: "100%",
  maxWidth: 640,
  margin: "0 auto",
  padding: "16px 24px 24px",
  color: "#64748b",
};

/**
 * Shared layout shell for all platform-subdomain pages
 * (manage.openings.link, booking.openings.link, share.openings.link, etc.).
 *
 * Provides centred, max-width-constrained content on a white background.
 * Each page is responsible for rendering its own header
 * (business name + PoweredByOpenings) and content.
 */
const PlatformShell = ({ children }: PlatformShellProps) => {
  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <div style={innerStyle}>{children}</div>
      </div>
      <footer style={footerStyle}>
        <PrivacyChoicesLink />
      </footer>
    </div>
  );
};

export default PlatformShell;
